/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { football_fields } from 'src/assets/newFootballFields';
import { FieldInfo } from '../map/map.component';
import {
  AnalyticsService,
  LANDING_ACTIONS,
  TRACK_ACTION,
} from '../services/analytics.service';
import { DimensionsService } from '../services/dimensions.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  clientWidth: number;

  exampleFields: FieldInfo[] = [];

  emailInput: string = '';
  textInput: string = '';

  get football_fields_json() {
    return football_fields;
  }

  constructor(
    private router: Router,
    private analyticsService: AnalyticsService,
    private toastController: ToastController,
    private dimensionsService: DimensionsService
  ) {}

  ngOnInit() {
    this.clientWidth = this.dimensionsService.getClientWidth();

    this.exampleFields = this.football_fields_json.slice(15, 19);
  }

  async openInfo(fieldInfo: FieldInfo) {
    this.trackAction(TRACK_ACTION.OPEN_FROM_LANDING, fieldInfo);

    this.router.navigate(['field-info'], {
      queryParams: { title: fieldInfo.title.trim().replace(/\ /g, '-') },
    });
  }

  trackAction(
    trackAction: TRACK_ACTION,
    fieldInfo?: FieldInfo | LANDING_ACTIONS
  ) {
    this.analyticsService
      .trackAction(trackAction, fieldInfo)
      .subscribe((res) => console.log(res));
  }

  sendFeedback() {
    this.analyticsService
      .sendFeedback(this.emailInput, this.textInput)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.openToast('success');

          this.textInput = '';
          this.emailInput = '';
        } else {
          this.openToast('error');
        }
      });
  }

  async openToast(res: string) {
    const toast = await this.toastController.create({
      header:
        res === 'success'
          ? 'Сообщение отправлено! Мы свяжемся с вами в ближайшее время'
          : 'Что-то пошло не так. Попробуйте снова или свяжитесь с нами через страницу Контакты',
      duration: 3000,
      color: res === 'success' ? 'success' : 'danger',
    });

    await toast.present();
  }

  get TRACK_ACTION() {
    return TRACK_ACTION;
  }

  get LANDING_ACTIONS() {
    return LANDING_ACTIONS;
  }
}
